import {FormattedMessage, useIntl} from "react-intl";
import {Modal, Box} from "@mui/material";

import React, {useState} from "react";
import SportIcon from "../../../components/SportIcon/SportIcon";
import GlobalConst from "../../../constants/GlobalConst";
import Currency from "../../../components/Currency/Currency";
import _ from "lodash";

import "./WelcomePopUps.style.scss";
import {PayoutModel} from "../../../constants/PickXEnums";
import Pick12PayoutCalculator from "../../../services/Pick12ParlayPayoutCalculator";
import Pick16PayoutCalculator from "../../../services/Pick16ParlayPayoutCalculator";
import {useGetRollingPrizeQuery} from "../../../stores/pickX/pickX.api";

const PrizeAssetWelcomePopUp = ({id, title, subTitle, open, onClose, onCancel, onOk, options, data}) => {
    const {locale} = useIntl();

    const {preSelectedParlay} = data;

    const storageKey = "dontShowAgain_p12p16WelcomePopUp";
    const league = GlobalConst.LEAGUES_BY_SPORT_ID[preSelectedParlay.SportIds[0]];
    const nbPicks = preSelectedParlay.ContestIds.length;
    const Calculator = preSelectedParlay.PayoutModel === PayoutModel.Pick12 ? Pick12PayoutCalculator : Pick16PayoutCalculator;
    const {data:rollingPrize} = useGetRollingPrizeQuery({
        currency: preSelectedParlay.FeeCurrency,
        wager: preSelectedParlay.Fee,
        sportId:preSelectedParlay.SportIds[0],
        payoutModel: preSelectedParlay.PayoutModel
    });
    const payoutInfos = new Calculator().calculateDistribution(preSelectedParlay.Fee, rollingPrize?.RollingAmount ?? 0.0);
    const prizeAmount = _.last(payoutInfos)?.payout ?? 0.0;
    const [dontShowAgain, setDontShowAgain] = useState(localStorage.getItem(storageKey) === "true");

    const onDontShowAgainChange = ()=>{
        const val = !dontShowAgain;
        setDontShowAgain(val);
        localStorage.setItem(storageKey, val.toString());
    }

    return (
        <Modal
            open={open}
            onClose={onClose}
            aria-labelledby="PrizeAssetWelcomePopUp-title"
            aria-describedby="PrizeAssetWelcomePopUp-description"
            className={"WelcomePopUp Generic"}

        >
            <Box className="modal-box">
                <div className={"header " + league}>
                    <button
                       className={"closeButton"}
                       onClick={onClose}>X</button>

                    <div className="name">
                        <SportIcon sportId={9} />
                        {league} PICK {nbPicks}
                    </div>
                    <div className={"payout"}><Currency currency={preSelectedParlay.FeeCurrency}
                                                            value={prizeAmount}
                                                            className={"gold-gradient-text"}
                                                            removeDecimal /></div>

                    <div className={"entryFee"}><FormattedMessage id={"popups.welcomePopUp.generic.entryFee"} />: <Currency currency={GlobalConst.SITE_CURRENCY}
                                                                                                                            value={preSelectedParlay.Fee}
                                                                                                                            removeDecimal/></div>

                </div>
                <div className="modal-content">

                    <ol>
                        <li><FormattedMessage id={"popups.welcomePopUp.generic.pickXOverOrUnder"}
                                              values={{nbPicks: <b>{nbPicks}</b>}} /></li>
                        <li><FormattedMessage id={"popups.welcomePopUp.generic.enterTheContest"} /></li>
                        <li>
                            <FormattedMessage id={"popups.welcomePopUp.generic.winGrandPrize"}
                                              values={{
                                                  nbPicks: <b>{nbPicks}</b>,
                                                  amount: <b><Currency currency={preSelectedParlay.FeeCurrency} value={prizeAmount} removeDecimal/></b>
                                              }} />
                        </li>
                    </ol>

                    <button onClick={onOk}>
                        <FormattedMessage id={"popups.welcomePopUp.generic.makeYourPicks"} />
                    </button>
                    <div className="dontShowAgain checkbox white"
                         onClick={onDontShowAgainChange}>
                        <input type="checkbox"
                               id="dontShowAgain"
                               name="dontShowAgain"
                               checked={dontShowAgain}/>
                        <label htmlFor="term1">
                            <FormattedMessage id={"popups.welcomePopUp.generic.dontShowAgain"} />
                        </label>
                    </div>

                </div>
            </Box>
        </Modal>
    );
};

export default PrizeAssetWelcomePopUp;